<!-- <mat-form-field class="full-width">
    <span matPrefix>
        <mat-icon>search</mat-icon>
    </span>
    <input matInput #filter placeholder="Buscar..." />
</mat-form-field> -->
<div class="contenedor-tabla">
    <mat-table
        class="contratistas-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="p.nombres"
        matSortDisableClear
        matSortDirection="asc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="p.nombres">
            <mat-header-cell *matHeaderCellDef class="column-nombres"
                ><strong>Nombres</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista" class="column-nombres">
                <a [routerLink]="'/contratistas/' + contratista.nrRut">
                    <span class="cursor-pointer">
                        {{ contratista.nombres }}
                    </span>
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="p.apellidos">
            <mat-header-cell *matHeaderCellDef class="column-apellidos"
                ><strong>Apellidos</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista" class="column-apellidos">
                <a [routerLink]="'/contratistas/' + contratista.nrRut">
                    <span class="cursor-pointer">
                        {{ contratista.apellidos }}
                    </span>
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="p.nrrut">
            <mat-header-cell *matHeaderCellDef class="column-rut"
                ><strong>Rut</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista" class="column-rut">
                <a [routerLink]="'/contratistas/' + contratista.nrRut">
                    {{ contratista.rut }}
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="evaluacion">
            <mat-header-cell *matHeaderCellDef
                ><strong>Calificación</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista">
                <p>
                    <app-star-rating
                        [evaluacion]="contratista.evaluacion"
                        [rutContratista]="contratista.rut"
                        [seteable]="false"
                        [cantidadEstrellas]="config.rating.cantidadEstrellas"
                    ></app-star-rating>
                </p>
            </mat-cell>
        </ng-container>

        <!--<ng-container matColumnDef="vigente">
            <mat-header-cell *matHeaderCellDef
                ><strong>Eliminado</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista">
                <span
                    *ngIf="contratista.fechaTermino"
                    class="green-600 s-16 p-4"
                    >SI</span
                >
                <span *ngIf="!contratista.fechaTermino" class="red-500 s-16 p-4"
                    >NO</span
                >
            </mat-cell>
        </ng-container>-->

        <ng-container matColumnDef="activo">
            <mat-header-cell *matHeaderCellDef
                ><strong>Activo</strong></mat-header-cell
            >
            <mat-cell *matCellDef="let contratista">
                <span *ngIf="contratista.activo" class="green-600 s-16 p-4"
                    >Activo</span
                >
                <span *ngIf="!contratista.activo" class="red-500 s-16 p-4"
                    >Inactivo</span
                >
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <mat-row *matRowDef="let contratista; columns: displayedColumns">
        </mat-row>
    </mat-table>
    <p *ngIf="dataSource.data.length === 0">
        <strong>No se han encontrado contratistas</strong>
    </p>
    <mat-paginator
        #paginator
        [length]="_contratistaSrvc.getTotalDeResultados()"
        [pageIndex]="_contratistaSrvc.getPaginaActual()"
        [pageSize]="_contratistaSrvc.getCantidaResultadosPorPagina()"
        [pageSizeOptions]="[1, 2, 5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
